export default "__VITE_ASSET__ZJIEHqGR__"